/* eslint-disable no-sparse-arrays */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */

import React from 'react';
import { VirtualizedList } from 'react-native';

const defaultGetItemCount = (data) => (Array.isArray(data) ? data.length : 0);
const defaultGetItem = (data, index) =>
  Array.isArray(data) ? data[index] : undefined;

export const LegendList = React.forwardRef((props, ref) => {
  const { data = [], getItemCount, getItem, ...rest } = props;

  return (
    <VirtualizedList
      ref={ref}
      data={data}
      getItemCount={getItemCount || defaultGetItemCount}
      getItem={getItem || defaultGetItem}
      {...rest}
    />
  );
});

LegendList.displayName = 'LegendListWebShim';
